import { ServiceOrderDueDateStatusEnum } from "../Services/api/service-orders/service-order.interface";

// export enum ServiceOrderDueDateStatusEnum {
//     ON_TIME = "ON_TIME",
//     DELAYED = "DELAYED",
//     EXPIRED = "EXPIRED",
//   }

  
export const labelsTimeStatusProduction : Record<ServiceOrderDueDateStatusEnum, string> = {
    DELAYED: 'Atrasado',
    ON_TIME: 'No prazo',
    EXPIRED: 'Vencido'      
};


export const normalizeTimeStatusColors = (status: ServiceOrderDueDateStatusEnum): { bgColor: string; textColor: string } => {
    const bgColor: Record<ServiceOrderDueDateStatusEnum, string> = {
        DELAYED: 'rgba(255, 193, 7, 0.7)', 
        ON_TIME: 'rgba(76, 175, 80, 0.7)', 
        EXPIRED: 'rgba(247, 0, 0, 0.7)'
    };

    const textColor: Record<ServiceOrderDueDateStatusEnum, string> = {
        DELAYED: '#212121',
        ON_TIME: '#FFFFFF',
        EXPIRED: '#FFFFFF'
    };

    return {
        bgColor: bgColor[status] || 'rgba(0,0,0,0.5)',
        textColor: textColor[status] || '#FFFFFF'
    };
};
